/**
 * @fileoverview
 * Tracking senders - pixel tracking and session-aware tracking.
 *
 * This barrel export provides focused access to tracking sender functions.
 */

export { sendPixelTracking } from './sendPixelTracking'
export { sendPixelTrackingWithSession } from './sendPixelTrackingWithSession'

// Helper exports commonly used with senders
export {
  appContextToTrackingData,
  appContextToTrackingDataPixel,
} from './helpers/appContext'
export { nowAndNowLocalToString } from './helpers/nowAndNowLocal'
export { getTrackingProduct, locale } from './helpers/tracking.utils'
